import React from 'react';
import { StackYoutubeVariant, StackYoutubePlayerProps } from '../../StackYouTubePlayer/StackYouTubePlayer';
import { ContentfulYoutube } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from './AssetTransformer';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';

export abstract class YouTubeTransformer {
  static toYoutubePlayerProps = (
    { fields }: ContentfulYoutube,
    variant: StackYoutubeVariant = 'default'
  ): StackYoutubePlayerProps => {
    return {
      videoUrl: fields?.url,
      landscapeThumbnail: fields?.landscapeCoverImage ? (
        <ContentfulImage {...AssetTransformer.toContentfulImageProps(fields.landscapeCoverImage)} />
      ) : undefined,
      portraitThumbnail: fields?.portraitCoverImage ? (
        <ContentfulImage {...AssetTransformer.toContentfulImageProps(fields.portraitCoverImage)} />
      ) : undefined,
      variant: variant,
    };
  };
}
